export default "__VITE_ASSET__hKSX5UNP__"